var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { Fragment } from "react";
import { ProgressDots } from '@atlaskit/progress-indicator';
import Button from '@atlaskit/button';
import { Field } from "@atlassiansox/microscopekit";
import { RadioGroup } from '@atlaskit/radio';
import Textfield from '@atlaskit/textfield';
import CrossIcon from '@atlaskit/icon/glyph/cross';
import showdown from 'showdown';
import styled from "styled-components";
import { useCredoDispatch, useCredoState } from "../../credo-context";
var ErrorMessage = require("@atlaskit/form").ErrorMessage;
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex\n  flex-direction: column;\n  height: 100%;\n  width: 100%;\n"], ["\n  display: flex\n  flex-direction: column;\n  height: 100%;\n  width: 100%;\n"])));
var Header = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  height: 35px;\n  min-height: 35px;\n  padding-top: 22px;\n  flex-grow: 0;\n  > :nth-child(2) {\n    cursor: pointer;\n  }\n"], ["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  height: 35px;\n  min-height: 35px;\n  padding-top: 22px;\n  flex-grow: 0;\n  > :nth-child(2) {\n    cursor: pointer;\n  }\n"])));
var Body = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  overflow: scroll;\n"], ["\n  overflow: scroll;\n"])));
var Footer = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  margin-top: 15px;\n  height: 50px;\n"], ["\n  margin-top: 15px;\n  height: 50px;\n"])));
var ProgressContainer = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  margin: 10px -15px;\n"], ["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  margin: 10px -15px;\n"])));
var CredoStepProgress = function (_a) {
    var onClose = _a.onClose;
    var state = useCredoState();
    var dispatch = useCredoDispatch();
    var converter = new showdown.Converter();
    var nextStep = function () {
        if (state.step < state.credoTopics.length - 1) {
            dispatch({ type: 'setStep', data: { value: state.step + 1 } });
        }
        else {
            dispatch({ type: 'setPage', data: { value: state.page + 1 } });
        }
    };
    var prevStep = function () {
        if (state.step !== 0) {
            dispatch({ type: 'setStep', data: { value: state.step - 1 } });
        }
        else {
            dispatch({ type: 'setPage', data: { value: state.page - 1 } });
        }
    };
    var setStep = function (step) {
        dispatch({ type: 'setStep', data: { value: step } });
    };
    return (React.createElement(Container, null,
        React.createElement(Header, null,
            React.createElement("h3", { dangerouslySetInnerHTML: { __html: converter.makeHtml(state.credoTopics[state.step].title) } }),
            React.createElement(CrossIcon, { size: "small", label: "close", onClick: onClose })),
        React.createElement(Body, null, state.credoTopics[state.step].questions.map(function (q, index) { return (React.createElement(Fragment, null,
            React.createElement(Field, { key: state.step + q.id, name: q.id, label: React.createElement("span", { dangerouslySetInnerHTML: { __html: converter.makeHtml(q.question) } }) }, function () { return (React.createElement(RadioGroup, { value: state.credoResponses[state.step].answers[index].option, options: q.options.map(function (o) { return ({
                    label: o.label,
                    name: o.option,
                    value: o.option
                }); }), onChange: function (e) {
                    dispatch({ type: 'setAnswer', data: { stepId: state.step, questionId: index, option: e.target.value } });
                } })); }),
            (q.options.find(function (o) { return (o.option === state.credoResponses[state.step].answers[index].option); }) || { details: undefined }).details ?
                React.createElement(Field, { key: index + state.step + 'details', name: index + "_details", isRequired: true }, function () { return ([
                    React.createElement(Textfield, { name: index + "_details", placeholder: (q.options.find(function (o) { return (o.option === state.credoResponses[state.step].answers[index].option); }) || { details: null }).details || undefined, value: state.credoResponses[state.step].answers[index].details || undefined, onChange: function (e) {
                            dispatch({
                                type: 'setDetails',
                                data: { stepId: state.step, questionId: index, details: e.target.value }
                            });
                        }, isInvalid: !!state.credoResponses[state.step].answers[index].error }),
                    state.credoResponses[state.step].answers[index].error ?
                        React.createElement(ErrorMessage, null, state.credoResponses[state.step].answers[index].error) :
                        undefined
                ]); }) : undefined)); })),
        React.createElement(Footer, null,
            React.createElement(ProgressContainer, null,
                React.createElement(Button, { onClick: prevStep }, "Prev"),
                React.createElement(ProgressDots, { selectedIndex: state.step, values: state.credoTopics, onSelect: function (_a) {
                        var index = _a.index;
                        return setStep(index);
                    } }),
                React.createElement(Button, { onClick: nextStep, appearance: 'primary' }, state.step + 1 > state.credoTopics.length - 1 ? 'Review' : 'Next')))));
};
export default CredoStepProgress;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
